import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import InputBox from './InputBox';
import _ from 'lodash';
import nanoid from 'nanoid';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import SnackBar from './SnackBar';


// okasboxes add new device

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '10%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


export default class MemberLicenseAddNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      errorMessage: [],
      MemberLicenseID: '',
      modalIsOpenSuccess: false,
      showErrorMessage: false,
      OBAvailable: true,
      addAnotherSuccess: false,
      loader: false,
      snackbarActive: false,
      snackbarMessage: '',
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModalSuccess() {
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpenSuccess: false
        }, () => this.props.refreshDevices())
      }, 500);

    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  componentDidMount(){
    this.generateMemberID()
  }
  generateMemberID = (e) => {
    let id = this.makeid(16);
    this.setState({
      MemberLicenseID: id.toUpperCase() 
    })
  }

  makeid = (length) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }



  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        })
        this.props.refreshDevices()
      }, 500);

    })
  }

  AddingML = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    let licenseNo = this.state.MemberLicenseID;
    let status = 'unassigned';

    fetch('/cloud/memberLicenseApi/',{
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        licenseNo,
        status
      })
    })
    .then(response =>response.json())
    .then((data)=>{    
      console.log(data)  
      if(data.message==="success"){
        this.setState({
          modalIsOpen:false,
          modalIsOpenSuccess:true,
          loader: false,
        })
      }else{     
        this.setState({
          loader: false,
          snackbarActive: true,
          snackbarMessage: data.message
        
        })      
        // alert(errorLog);  
    }
    })
    .catch((err)=>{
      console.log(err)

    })


  }

  AddingAnotherML = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    let licenseNo = this.state.MemberLicenseID;
    let status = 'unassigned';

    fetch('/cloud/memberLicenseApi/',{
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        licenseNo,
        status
      })
    })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
          .then(data => {
            if (data.message === "success") {
              this.generateMemberID()
              this.setState({
                modalIsOpen: false,
                addAnotherSuccess: true,
                obData: data,
                loader: false
              }, () => {
                setTimeout(() => {
                  this.setState({
                    addAnotherSuccess: false
                  })
                }, 3000)
                this.setState({
                  modalIsOpen: true,
                  showErrorMessage: false
                }, () => this.fetch)
              })
            } else {
              this.setState({
                loader: false,
                snackbarActive: true,
                snackbarMessage: data.message
              },()=>{
                this.generateMemberID()
              })
            }
          })
          .catch((err)=>{
            console.log(err)
          })
      }


  AddML = () => {
    this.AddingML();
  }

  AddAnotherML = () => {
    this.AddingAnotherML();
  }

  render() {
    return (
      <React.Fragment>
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
        {this.state.loader ? <Loader /> : null}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}}>Add Member License</h3>
          <div className="row">
            {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
              Successfully registered the member license.
          </div> : null}
          </div>
          <div className="row" style={{margin: '0px', padding: '0px'}}>          
            <div className="col-12 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
              <InputBox
                inputText={this.state.MemberLicenseID}
                placeholder="Member License"
                inputBoxName="memberLicense"
                textLength={16}
                validate={true}      
                disableEvent={true}          
              />
            </div>
          </div>
          <div className="float-right" style={{marginTop: '70px', marginBottom: '70px'}}>
            <div className="btn btn-new-grey" style={{marginRight: '15px'}} onClick={this.closeModal}>Close</div>
            <div className="btn btn-new-orange" style={{marginRight: '15px'}} onClick={this.AddAnotherML.bind(this)}>Add Another</div>
            <div className="btn btn-new-green" 
            onClick={()=>{
              this.setState({
                loader:true
              },()=>{
                this.AddML()
              })
            }}
            onClick={this.AddML.bind(this)}
            >Add</div>         
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2" onClick={this.closeModalSuccess}></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Member license added successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5"
              onClick={this.closeModalSuccess}
              >
              Close
                            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
